import { useEffect } from "react";
import { Volume2, Send, Pencil } from "lucide-react";
import { speak } from "@/lib/api";
import { ChatbotHandoff } from "@/components/ChatbotHandoff";

export const HeardCard = ({ age, check, text, onProceed, onEdit }) => {
  const line = `${age === "kid" ? "Thank you for asking so nicely!" : "Thanks for asking politely."} ${check.heard}`;
  useEffect(() => { speak(line); }, [line]);

  return (
    <section className="pp-card gate-ok" data-testid="ai-heard-confirmation-card">
      <p className="pp-label">Step 3 · What the AI heard</p>
      <h2 className="pp-h2">{age === "kid" ? "Great manners! Here's what I heard:" : "Please received. Here's what I understood:"}</h2>
      <p className="pp-quote" data-testid="polite-directive-text">“{text}”</p>
      <p className="pp-heard" data-testid="interpreted-intent-text">{check.heard}</p>
      {check.feedback && <p className="pp-feedback small" data-testid="coaching-feedback-text">{check.feedback}</p>}
      {check.gratitude ? (
        <p className="pp-golden-badge" data-testid="gratitude-request-badge">
          <img src="/acorn-t.png" alt="" /> Gratitude words! You'll earn a golden acorn.
        </p>
      ) : check.level_up && (
        <p className="pp-levelup" data-testid="level-up-suggestion">
          <b>Level up next time for a golden acorn:</b> “{check.level_up}”
        </p>
      )}
      <div className="pp-actions">
        <button data-testid="audio-play-simulation-button" className="pp-ghost" onClick={() => speak(line)}>
          <Volume2 className="h-4 w-4" /> Hear it
        </button>
        <button data-testid="edit-directive-button" className="pp-ghost" onClick={onEdit}>
          <Pencil className="h-4 w-4" /> That's not it
        </button>
        <button data-testid="proceed-to-ai-button" className="pp-primary" onClick={onProceed}>
          Yes, send it <Send className="h-5 w-5" />
        </button>
      </div>
      <ChatbotHandoff text={text} />
    </section>
  );
};
